import React from 'react';
import PropTypes from 'prop-types';

import FilterNumberPair from 'components/search_sidebar/filter_number_pair';
import FilterSelect from 'components/search_sidebar/filter_select';
import FilterCheckboxGroup from 'components/search_sidebar/filter_checkbox_group';

import { Col, Form, Row } from 'react-bootstrap-5';

export default class IndustrialFilters extends React.Component {
  static propTypes = {
    availableRailProviders: PropTypes.array.isRequired,
    filterKeyMappings: PropTypes.object.isRequired,
    filterLabelMappings: PropTypes.object.isRequired,
    industrialFilter: PropTypes.object.isRequired,
    lotBorderTypes: PropTypes.array.isRequired,
    lotStabilizations: PropTypes.array.isRequired,
    servedRailProviders: PropTypes.array.isRequired,
    onIndustrialFilterChange: PropTypes.func.isRequired,
  };

  handleChange = (e, name, checkbox = false) => {
    this.props.onIndustrialFilterChange(e, name, checkbox);
  };

  render() {
    return (
      <Row>
        <Col md={6}>{this.renderCraneFilters()}</Col>
        <Col md={6}>
          <div className="d-flex flex-column gap-3">
            {this.renderYardFilters()}
            {this.renderRailFilters()}
            {this.renderOtherFilters()}
          </div>
        </Col>
      </Row>
    );
  }

  renderOtherFilters() {
    const { industrialFilter, filterLabelMappings } = this.props;

    return (
      <div className="d-none d-md-flex flex-column gap-2">
        <h6 className="pb-1 border-bottom fw-semibold fs-large">Other</h6>
        <Row>
          <Col>
            <Form.Label className="d-flex align-items-center gap-1">
              <Form.Check
                checked={industrialFilter.driveThroughAccess}
                name=""
                onChange={e => this.handleChange(e, 'driveThroughAccess', true)
                }
              />
              {filterLabelMappings['driveThroughAccess']}
            </Form.Label>
          </Col>
        </Row>
      </div>
    );
  }

  renderRailFilters() {
    const {
      availableRailProviders,
      servedRailProviders,
      filterLabelMappings,
      industrialFilter,
    } = this.props;

    return (
      <div className="d-none d-md-flex flex-column gap-2">
        <h6 className="pb-1 border-bottom fw-semibold fs-large">Rail</h6>
        <Row>
          <Col md={6}>
            <FilterCheckboxGroup
              label={filterLabelMappings['servedRailProvider']}
              options={servedRailProviders}
              selected={[industrialFilter.servedRailProvider]}
              onChange={e => this.handleChange(e, 'servedRailProvider')}
            />
          </Col>
          <Col md={6}>
            <FilterCheckboxGroup
              label={filterLabelMappings['availableRailProvider']}
              options={availableRailProviders}
              selected={[industrialFilter.availableRailProvider]}
              onChange={e => this.handleChange(e, 'availableRailProvider')}
            />
          </Col>
        </Row>
      </div>
    );
  }

  renderYardFilters() {
    const {
      filterKeyMappings,
      filterLabelMappings,
      lotBorderTypes,
      lotStabilizations,
      industrialFilter,
    } = this.props;

    return (
      <div className="d-none d-md-flex flex-column gap-2">
        <h6 className="pb-1 border-bottom fw-semibold fs-large">Yard</h6>
        <Row>
          <Col>
            <FilterNumberPair
              filter={industrialFilter}
              label={filterLabelMappings['acresStabilized']}
              name="acresStabilized"
              valueKeys={filterKeyMappings['acresStabilized']}
              onChange={this.handleChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FilterCheckboxGroup
              inline
              label={filterLabelMappings['lotStabilization']}
              options={lotStabilizations}
              selected={[industrialFilter.lotStabilization]}
              onChange={e => this.handleChange(e, 'lotStabilization')}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FilterCheckboxGroup
              inline
              label={filterLabelMappings['lotBorderType']}
              options={lotBorderTypes}
              selected={[industrialFilter.lotBorderType]}
              onChange={e => this.handleChange(e, 'lotBorderType')}
            />
          </Col>
        </Row>
      </div>
    );
  }

  renderCraneFilters() {
    const { filterKeyMappings, filterLabelMappings, industrialFilter } =
      this.props;

    return (
      <div className="d-flex flex-column gap-2">
        <h6 className="d-none d-md-block pb-1 border-bottom fw-semibold fs-large">
          Crane
        </h6>
        <Row>
          <Col>
            <Form.Label className="d-flex align-items-center gap-1">
              <Form.Check
                checked={industrialFilter.served}
                name=""
                onChange={e => this.handleChange(e, 'served', true)}
              />
              {filterLabelMappings['served']}
            </Form.Label>
          </Col>
        </Row>
        <Row>
          <Col>
            <FilterNumberPair
              filter={industrialFilter}
              label={filterLabelMappings['numBridgeCranes']}
              name="numBridgeCranes"
              valueKeys={filterKeyMappings['numBridgeCranes']}
              onChange={this.handleChange}
            />
          </Col>
        </Row>
        <Row className="align-items-end gx-2">
          <Col md={9}>
            <FilterNumberPair
              filter={industrialFilter}
              label={filterLabelMappings['bridgeCraneSpan']}
              name="bridgeCraneSpan"
              valueKeys={filterKeyMappings['bridgeCraneSpan']}
              onChange={this.handleChange}
            />
          </Col>
          <Col className="d-none d-md-flex" md={3}>
            <FilterSelect disabled placeholder="Feet" />
          </Col>
        </Row>
        <Row>
          <Col>
            <FilterNumberPair
              filter={industrialFilter}
              label={filterLabelMappings['numJibCranes']}
              name="numJibCranes"
              valueKeys={filterKeyMappings['numJibCranes']}
              onChange={this.handleChange}
            />
          </Col>
        </Row>
        <Row className="align-items-end gx-2">
          <Col md={9}>
            <FilterNumberPair
              filter={industrialFilter}
              label={filterLabelMappings['jibCraneSpan']}
              name="jibCraneSpan"
              valueKeys={filterKeyMappings['jibCraneSpan']}
              onChange={this.handleChange}
            />
          </Col>
          <Col className="d-none d-md-flex" md={3}>
            <FilterSelect disabled placeholder="Feet" />
          </Col>
        </Row>
        <Row className="d-none d-md-flex">
          <Col>
            <Form.Label className="d-flex align-items-center gap-1">
              <Form.Check
                checked={industrialFilter.ready}
                name=""
                onChange={e => this.handleChange(e, 'ready', true)}
              />
              {filterLabelMappings['ready']}
            </Form.Label>
          </Col>
        </Row>
        <Row className="align-items-end gx-2">
          <Col md={9}>
            <FilterNumberPair
              filter={industrialFilter}
              label={filterLabelMappings['readyCapacity']}
              name="readyCapacity"
              valueKeys={filterKeyMappings['readyCapacity']}
              onChange={this.handleChange}
            />
          </Col>
          <Col className="d-none d-md-flex" md={3}>
            <FilterSelect disabled placeholder="Tons" />
          </Col>
        </Row>
        <Row className="align-items-end gx-2">
          <Col md={9}>
            <FilterNumberPair
              filter={industrialFilter}
              label={filterLabelMappings['readySpan']}
              name="readySpan"
              valueKeys={filterKeyMappings['readySpan']}
              onChange={this.handleChange}
            />
          </Col>
          <Col className="d-none d-md-flex" md={3}>
            <FilterSelect disabled placeholder="Feet" />
          </Col>
        </Row>
      </div>
    );
  }
}
